import React from 'react';

const PreprodIllustration = (): JSX.Element => (
  <svg viewBox='0 0 400 360' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <defs>
      <pattern id='stripes-yellow' patternUnits='userSpaceOnUse' width='24' height='24' patternTransform='rotate(45)'>
        <rect width='12' height='24' fill='#FFD52E' />
        <rect x='12' width='12' height='24' fill='#FFF1A8' />
      </pattern>
    </defs>

    <circle cx='160' cy='180' r='130' fill='url(#stripes-yellow)' />

    <g fill='none' stroke='#000' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
      <ellipse cx='245' cy='110' rx='18' ry='20' fill='#fff' />
      <path d='M 230 95 Q 245 70 270 88 Q 268 80 263 78 Q 258 70 248 73 Q 232 77 228 92 Z' fill='#000' stroke='#000' />
      <circle cx='258' cy='118' r='2.2' fill='#000' />
      <line x1='245' y1='130' x2='245' y2='142' />
      <path d='M 224 148 Q 245 142 266 148 L 270 234 Q 245 238 220 234 Z' fill='#fff' />
      <path d='M 224 154 Q 200 178 198 218 L 204 224' />
      <path d='M 266 154 Q 286 172 290 210 L 286 218' />
      <rect x='183' y='220' width='36' height='48' fill='#fff' />
      <rect x='194' y='214' width='14' height='9' fill='#000' stroke='#000' />
      <line x1='190' y1='234' x2='212' y2='234' strokeWidth='1.5' />
      <line x1='190' y1='242' x2='212' y2='242' strokeWidth='1.5' />
      <line x1='190' y1='250' x2='205' y2='250' strokeWidth='1.5' />
      <line x1='190' y1='258' x2='212' y2='258' strokeWidth='1.5' />
      <path d='M 230 236 L 222 314 L 224 340' />
      <path d='M 260 236 L 268 314 L 266 340' />
      <ellipse cx='222' cy='345' rx='12' ry='5' fill='#000' stroke='#000' />
      <ellipse cx='266' cy='345' rx='12' ry='5' fill='#000' stroke='#000' />
    </g>

    <g transform='translate(290, 70)'>
      <rect x='0' y='0' width='68' height='32' rx='4' fill='#000' />
      <text
        x='34'
        y='21'
        fontFamily='DM Sans, system-ui, sans-serif'
        fontSize='13'
        fontWeight='700'
        fill='#FFD52E'
        textAnchor='middle'
        letterSpacing='0.5'
      >
        DRAFT
      </text>
    </g>
  </svg>
);

export default PreprodIllustration;
